import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useArea } from '../../contexts/AreaContext';
import QuestionComponent from '../../components/acoes/questions/QuestionComponent';
import { areaService, Area } from '../../services/areaService';
import { Alert } from 'react-bootstrap';

const AcaoAreaPage: React.FC = () => {
    const history = useHistory();
    const { areaId } = useParams<{ areaId: string }>();
    const { currentArea, clearCurrentArea } = useArea();

    const [error, setError] = React.useState<string | null>(null);
    const [areaInfo, setAreaInfo] = React.useState<Area | null>(null);

    React.useEffect(() => {

        const targetAreaId = currentArea?.area_id || areaId;

        if (currentArea && !areaId) {
            history.replace(`/acoes/area/${currentArea.area_id}`);
            return;
        }

        if (!targetAreaId || targetAreaId.trim() === '') {
            setError('ID da área não fornecido');
            return;
        }

        let isMounted = true;

        const fetchAreaInfo = async () => {
            try {
                setError(null);

                if (currentArea && currentArea.area_id === targetAreaId) {
                    setAreaInfo(currentArea);
                    return;
                }

                const areas = await areaService.getAreas();
                const foundArea = areas.find(area => area.area_id === targetAreaId);

                if (!isMounted) return;

                if (!foundArea) {
                    setError(`Área com ID ${targetAreaId} não encontrada`);
                    return;
                }

                setAreaInfo(foundArea);
            } catch (err) {
                console.error('Error fetching area info:', err);
                if (isMounted) {
                    setError('Erro ao carregar informações da área');
                }
            }
        };

        fetchAreaInfo();

        return () => {
            isMounted = false;
        };
    }, [areaId, currentArea]);


    if (error) {
        return (
            <div className="container mt-4">
                <Alert variant="danger">
                    <Alert.Heading>Erro</Alert.Heading>
                    <p>{error}</p>
                    <hr />
                    <div className="d-flex justify-content-end">
                        <button
                            className="btn btn-outline-danger"
                            onClick={() => {
                                clearCurrentArea();
                                history.push('/acoes');
                            }}
                        >
                            Voltar para Ações
                        </button>
                    </div>
                </Alert>
            </div>
        );
    }

    if (!areaInfo) {
        return (
            <div className="container mt-4">
                <Alert variant="warning">
                    <Alert.Heading>Área não encontrada</Alert.Heading>
                    <p>A área solicitada não foi encontrada.</p>
                    <hr />
                    <div className="d-flex justify-content-end">
                        <button
                            className="btn btn-outline-warning"
                            onClick={() => {
                                clearCurrentArea();
                                history.push('/acoes');
                            }}
                        >
                            Voltar para Ações
                        </button>
                    </div>
                </Alert>
            </div>
        );
    }

    return (
        <div className="educacao-page">
            <QuestionComponent
                title={`Questões da ${areaInfo.nome}`}
                onReturn={() => {
                    clearCurrentArea();
                    history.push('/acoes');
                }}
                moduleType="educacao"
            />
        </div>
    );
};

export default AcaoAreaPage; 